<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form custom-form-1">
        <div class="search-form-box">
          <el-row :gutter="30">
            <el-form inline>
              <el-col :span="6">
                <el-form-item label="姓名/电话:">
                  <el-input
                    style="width: 100%"
                    clearable
                    v-model="searchForm.keyword"
                    autocomplete="off"
                    placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发起时间:">
                  <custom-date-range
                    :start-date="searchForm.createTimeStart"
                    :end-date="searchForm.createTimeEnd"
                    @update:startDate="
                      (val) => (searchForm.createTimeStart = val)
                    "
                    @update:endDate="(val) => (searchForm.createTimeEnd = val)"></custom-date-range>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审批结果:" prop="auditStatus">
                  <el-select
                    style="width: 100%"
                    v-model="searchForm.auditStatus"
                    filterable
                    allow-create
                    default-first-option
                    clearable
                    placeholder="请选择">
                    <el-option
                      v-for="item in $dict.driverAuditStatusOptions"
                      :key="item.dictCode"
                      :label="item.dictLabel"
                      :value="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="">
                  <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                  <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
        <custom-table
          :data="tableData"
          :column="tableColumn"
          height="auto"
          :total="tableOptions.total"
          :loading="tableOptions.loading"
          :page="tableOptions.pageNumber"
          :size="tableOptions.pageSize"
          :selection="false"
          @pagination="handleSizeChange">
          <!--          <template v-slot:status="{ row }">-->
          <!--            <div class="operate">-->

          <!--              <span class="common-status status-confirm"> 已通过</span>-->
          <!--              <span class="common-status status-pending-order"> 待审批</span>-->
          <!--              <span class="common-status status-pending-order"> 已撤销</span>-->
          <!--              <span class="common-status status-pending-order"> 已驳回</span>-->
          <!--            </div>-->
          <!--          </template>-->
          <template v-slot:auditStatus="{ row }">
            <span class="common-status status-error" v-if="row.auditStatus === -1">已驳回</span>
            <span class="common-status status-cancel" v-if="row.auditStatus === 2">已撤销</span>
            <span class="common-status status-confirm" v-if="row.auditStatus === 1">已通过</span>
            <span class="common-status status-pending-order" v-if="row.auditStatus === 0">待审批</span>
          </template>
          <template v-slot:operation="{ row }">
            <span
              class="operate-btn"
              :class="row.auditStatus === 0 ? '' : 'disable-txt'"
              @click="row.auditStatus === 0 ? handleReturn(row) : ''">
              撤回
            </span>
            <span class="operate-btn" @click="openDetail(row)">详情</span>
          </template>
        </custom-table>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { getHistory } from "./api";
import { rollbackDriver } from "@/views/ApprovalCenter/DriverInformationApproval/api";
import tableMixin from "@/mixin/tableMixin";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
export default {
  name: "HistoricalRecords",
  mixins: [tableMixin],
  components: {
    CustomDateRange,
    DialogContainer,
    CustomTable,
  },
  data() {
    return {
      searchForm: {
        auditStatus: "",
        createTimeStart: "",
        createTimeEnd: "",
        keyword: "",
      },
      getTableMethod: getHistory,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "70%",
        show: false,
        title: "历史申请记录",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      tableColumn: [
        {
          label: "发起时间",
          prop: "createTime",
          align: "left",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "username",
          align: "left",
          show: true,
        },
        {
          label: "联系方式",
          prop: "phone",
          align: "left",
          show: true,
        },
        {
          label: "所属机构",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "车牌号码",
          prop: "carNumber",
          align: "left",
          show: true,
        },
        {
          label: "车型",
          prop: "vehicleMode",
          align: "left",
          show: true,
        },
        {
          label: "车长",
          prop: "vehicleLength",
          align: "left",
          show: true,
        },
        {
          label: "审批状态",
          prop: "auditStatus",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "120px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },

  mounted() {},
  methods: {
    // 撤销
    handleReturn(row) {
      this.$confirm(`确定撤销此司机申请？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        rollbackDriver({
          auditRemark: "",
          driverId: row.driverId,
        }).then((res) => {
          if (res.code === 200) {
            this.getTableData();
          }
        });
      });
    },
    openDetail(row) {
      this.$emit("openDetail", row);
    },
    // getDetail(userId) {
    //   getHistory(userId).then((res) => {
    //     if (res.code === 200) {
    //       this.tableData = res.data;
    //     }
    //   });
    // },
    init(row) {
      this.getTableData();
      this.dialogObj.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .code-image {
    width: 1.2rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1269ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    color: #999999;
  }
}
.custom-form-1 {
  ::v-deep .table-container .table-box {
    flex-direction: row;
  }
}
</style>
